import React from "react";
import Select from "react-select";

export interface CustomSelectOption {
    value: string;
    label: string;
    status?: string;
    percentage?: number;
}

interface CustomSelectProps {
    options: CustomSelectOption[];
    value?: CustomSelectOption;
    onChange: (value: string) => void;
    placeholder?: string;
    isDisabled?: boolean;
    className?: string;
}

export const CustomSelect = ({
    options,
    value,
    onChange,
    placeholder = "Select an option",
    isDisabled = false,
    className,
}: CustomSelectProps) => {
    const CustomOption = ({ data, ...props }: any) => (
        <div {...props.innerProps} className={`custom-select__option ${props.isFocused ? "custom-select__option--is-focused" : ""}`}>
            <span>{data.label}</span>
            {data.status && (
                <div className="option-content">
                    <span className={`status status--${data.status.toLowerCase().replace(" ", "-")}`}>
                        {data.status}
                    </span>
                    {typeof data?.percentage === "number" && (
                        <span className="percentage">{Math.round(data.percentage)}%</span>
                    )}
                </div>
            )}
        </div>
    );

    return (
        <div className="custom-select-container">
            <Select
                options={options}
                value={value}
                onChange={(option) => onChange(option?.value || "")}
                placeholder={placeholder}
                isDisabled={isDisabled}
                className={`custom-select ${className || ""}`}
                classNamePrefix="custom-select"
                components={{ Option: CustomOption }}
            />
        </div>
    );
};